module.exports = __webpack_public_path__ + "img/sendgrid-full.21467751.webp";